var React = require('react');
var CreateReactClass = require('create-react-class');
var PropTypes = require('prop-types');

import Button from '../common/button.component';
import carteLegende from '../../img/legende.png';


var styles = {
    mainContenair : {
        position : 'absolute',
        top : 50,
        right : 5,
        zIndex: 2
    }
};

var RightControl = CreateReactClass({
    propTypes : {
        onClickGo:  PropTypes.func,
        onClickReset:  PropTypes.func,
        onClickList : PropTypes.func,
        onClickMarker : PropTypes.func,
        canAddParticipant : PropTypes.bool,
        legendeList : PropTypes.array,
    },
    defaultProps : {
       canAddParticipant : true
    },
    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.canAddParticipant !== this.props.canAddParticipant ||
            nextProps.legendeList !== this.props.legendeList
        ){
            return true;
        }
        return false;
    },
    render: function () {

        var renderLegend = function(legendeList){
            // console.log("rendering legend");
            if (legendeList.length>=4 ){
                return (
                    <div className="colFlexStretch" style={{margin : '30px 0 5px 0', backgroundImage : `url(${carteLegende})`, borderRadius: 4, border: '2px solid #313131', fontWeight: 700, fontSize : 15}}>
                        <div className="flexComponentOne ligneFlexCenteredCentered" style={{height: 35, color: 'rgb(10,10,10)', backgroundColor : 'rba(0,0,0,0)'}}>
                            <span>&lt;{legendeList[0]} min</span>
                        </div >
                        <div className="flexComponentOne ligneFlexCenteredCentered" style={{height: 35,  color: 'rgb(0,0,0)', backgroundColor : 'rgba(0, 0, 0, 0.3)'}}>
                            <span>&lt;{legendeList[1]} min</span>
                        </div >
                        <div className="flexComponentOne ligneFlexCenteredCentered" style={{height: 35, color: 'rgb(250,250,250)', backgroundColor : 'rgba(0,0,0,0.51)'}}>
                            <span>&lt;{legendeList[2]} min</span>
                        </div>

                        {legendeList.length==4 ? (
                            <div className="flexComponentOne ligneFlexCenteredCentered" style={{height: 35, color: 'rgb(240, 240, 240)', backgroundColor : 'rgba(0,0,0,0.66)'}}>
                                <span>&gt;{legendeList[3]} min</span>
                            </div>
                        ) : (<div className="flexComponentOne ligneFlexCenteredCentered" style={{height: 35, color: 'rgb(240,240,240)', backgroundColor : 'rgba(0,0,0,0.66)'}}>
                            <span>&lt;{legendeList[3]} min</span>
                        </div>)}

                        {legendeList.length==5 ? (
                            <div className="flexComponentOne ligneFlexCenteredCentered" style={{height: 35, color: 'rgb(235, 235, 235)', backgroundColor : 'rgba(0,0,0,0.74)'}}>
                                <span>&gt;{legendeList[4]} min</span>
                            </div>
                        ) : false}
                    </div>
                )
            }
            else {
                return false
            }
        };

        return (
            <div style={styles.mainContenair}>
                <div className="ligneFlexCenteredCentered" style={{margin : '15px 0 5px 0'}}>
                    <Button disabled={false} color={"#000000"} fontcolor={"#2fa5ff"} minwidth={65} faIcone={"fa-list-ul"} faIconeSize={""} text={" "} onClick={this.props.onClickList} />
                </div>
                <div className="ligneFlexCenteredCentered" style={{margin : '15px 0 5px 0'}}>
                    <Button disabled={false} color={"#000000"} fontcolor={"#2fd87d"} minwidth={65} faIcone={""} faIconeSize={""} text={" Go ! "} onClick={this.props.onClickGo} />
                </div>

                {this.props.canAddParticipant ? false : (
                    <div className="ligneFlexCenteredCentered" style={{margin : '15px 0 5px 0'}}>
                        <Button disabled={false} color={"#000000"} fontcolor={"#2fa5ff"} minwidth={65} faIcone={"fa-lg fa-map-marker"} faIconeSize={""} text={""} onClick={this.props.onClickMarker} />
                    </div>
                )}

                <div className="ligneFlexCenteredCentered" style={{margin : '30px 0 5px 0'}}>
                    <Button disabled={false} color={"#000000"} fontcolor={"#ff9700"} minwidth={65} faIcone={""} faIconeSize={""} text={"Clear"} onClick={this.props.onClickReset} />
                </div>

                {renderLegend(this.props.legendeList)}

            </div>
        );
    }
});

module.exports = RightControl;



// WEBPACK FOOTER //
// ./src/components/areaFinder/right-control.component.js